import { uglifiedAlphabet, vowels } from './utils';
var selectRandom = function (array) {
    return array[Math.floor(Math.random() * array.length)];
};
var starter = '⌊';
var ender = '⌋';
export var pseudolocalize = function (_a) {
    var textKey = _a.textKey, value = _a.value;
    if (textKey === value)
        return "".concat(starter).concat(value).concat(ender);
    var variableDepth = 0;
    var processedValue = value
        .split('')
        .map(function (letter) {
        if (letter === starter) {
            variableDepth++;
            return letter;
        }
        if (letter === ender) {
            variableDepth--;
            return letter;
        }
        if (variableDepth > 0) {
            return letter;
        }
        var choices = uglifiedAlphabet[letter];
        if (!choices)
            return letter;
        return vowels.indexOf(letter) !== -1
            ? [0, 1]
                .map(function () {
                return selectRandom(choices);
            })
                .join('')
            : selectRandom(choices);
    })
        .join('');
    return "".concat(starter).concat(processedValue).concat(ender);
};
